import React from 'react';
import { Database } from '../types/supabase';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { KanbanCard } from './KanbanCard';
import { useState } from 'react';
import { toast } from '../lib/toast';
import TaskDetails from './TaskDetails';

type Task = Database['public']['Tables']['tasks']['Row'];

interface KanbanColumnProps {
  id: string;
  title: string;
  tasks: Task[];
  className?: string;
  onEdit: (task: Task) => void;
  onDelete: (taskId: string) => void;
  onViewTask: (task: Task) => void;
  onToggleComplete: (taskId: string, completed: boolean) => void;
  onUpdateStatus?: (taskId: string, status: string) => void;
}

export function KanbanColumn({
  id,
  title,
  tasks,
  className = '',
  onEdit,
  onDelete,
  onViewTask,
  onToggleComplete,
  onUpdateStatus
}: KanbanColumnProps) {
  const { setNodeRef } = useDroppable({ id });
  const [selectedTask, setSelectedTask] = useState<Task | null>(null);
  
  const handleDelete = async (taskId: string) => {
    try {
      await onDelete(taskId);
      toast.success('Task deleted successfully');
    } catch (error) {
      console.error('Error deleting task:', error);
      toast.error('Failed to delete task');
    }
  };

  return (
    <div
      ref={setNodeRef}
      className={`flex-shrink-0 w-80 rounded-lg p-4 ${className}`}
    >
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center justify-between">
        {title}
        <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
          {tasks.length}
        </span>
      </h3>
      <SortableContext
        items={tasks.map((t) => t.id)}
        strategy={verticalListSortingStrategy}
      >
        <div className="space-y-3">
          {tasks.map((task) => (
            <KanbanCard
              key={task.id}
              task={task}
              onViewTask={(task) => setSelectedTask(task)}
              onEdit={onEdit}
              onDelete={handleDelete}
              onToggleComplete={onToggleComplete}
              onUpdateStatus={onUpdateStatus}
            />
          ))}
        </div>
      </SortableContext>
      {selectedTask && (
        <TaskDetails
          task={selectedTask}
          employees={[]}
          onClose={() => setSelectedTask(null)}
        />
      )}
    </div>
  );
}